import styled from 'styled-components';

import Section from 'pages/Account/components/Section';
import AvatorUploader from './components/AvatorUploader';
import UserInfo from './components/UserInfo';

const Container = styled.div`
  display: flex;
`;

const AvatorView = styled.div`
  border-right: 1px solid ${(props) => props.theme.global.borderColor};
  padding-right: 24px;
  margin-right: 24px;
`;

const ProfileSection = () => {
  return (
    <Section maxWidth={600}>
      <Container>
        <AvatorView>
          <AvatorUploader />
        </AvatorView>
        <UserInfo />
      </Container>
    </Section>
  );
};

export default ProfileSection;
